<template>
  <div class="lss-page">
    <div class="lss-bar">
      <span class="lss-title">일정계획 크롤링 화면</span>
      <span class="lss-state" :class="{ live: !!frameUrl }">{{ stateText }}</span>
    </div>
    <div class="lss-body">
      <img v-if="frameUrl" class="lss-img" :src="frameUrl" alt="크롤링 브라우저 화면" />
      <p v-else class="lss-empty">브라우저 화면을 기다리는 중…</p>
    </div>
  </div>
</template>

<script setup lang="ts">
import { onBeforeUnmount, onMounted, ref } from 'vue'
import { ltcsScheduleProbeApi } from '@/services/api'

const frameUrl = ref('')
const stateText = ref('연결 중')
let timer: ReturnType<typeof setInterval> | null = null
let busy = false

const tick = async () => {
  if (busy) return
  busy = true
  try {
    const res = await ltcsScheduleProbeApi.getScreen()
    const blob = res.data as Blob
    if (res.status === 200 && blob && blob.size > 0) {
      const url = URL.createObjectURL(blob)
      if (frameUrl.value) URL.revokeObjectURL(frameUrl.value)
      frameUrl.value = url
      stateText.value = '실시간'
    } else {
      stateText.value = '브라우저 대기 중'
    }
  } catch {
    stateText.value = '연결 실패'
  } finally {
    busy = false
  }
}

onMounted(() => {
  tick()
  timer = setInterval(tick, 900)
})

onBeforeUnmount(() => {
  if (timer) clearInterval(timer)
  if (frameUrl.value) URL.revokeObjectURL(frameUrl.value)
})
</script>

<style lang="scss" scoped>
.lss-page {
  min-height: 100vh;
  background: #101418;
  display: flex;
  flex-direction: column;
}

.lss-bar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 10px 16px;
  background: #1b222b;
}

.lss-title {
  font-size: 15px;
  font-weight: 800;
  color: #eceff1;
}

.lss-state {
  font-size: 13px;
  font-weight: 700;
  color: #90a4ae;

  &.live {
    color: #66bb6a;
  }
}

.lss-body {
  flex: 1;
  display: flex;
  align-items: flex-start;
  justify-content: center;
  padding: 12px;
}

.lss-img {
  max-width: 100%;
  border: 1px solid #37474f;
  border-radius: 6px;
  background: #000;
}

.lss-empty {
  margin-top: 80px;
  font-size: 15px;
  font-weight: 600;
  color: #78909c;
}
</style>
